import {useCallback, useEffect} from "react";
import {useSaveForCart} from "../data/queries";
import {useNotification} from "./useNotification";
import {useSetRecoilState} from "recoil";
import {stateLoading} from "../data/atoms";

export const useSubmitCart = () => {
    const setLoading = useSetRecoilState(stateLoading);

    const {showError, showSuccess} = useNotification();
    const {data, isLoading, isSuccess, isError, error, mutateAsync: save} = useSaveForCart();


    const addToCart = useCallback(async (componentsIds: string[], image: string) => {
        const settings = window.constructorSettings;
        const postAction = window.constructorPostAction;

        if (settings) {
            const {fragments, cart_hash} = await save({
                image,
                componentsIds,
                action: settings.action,
                nonce: settings.nonce,
            });

            if (postAction) {
                postAction(fragments, cart_hash);
            } else {
                showError(
                    '⚠️ Ошибка на сайте!',
                    [
                        'На сайте возникла техническая проблема, мы уже занимаемся её решением!',
                        'Пожалуйста, свяжитесь с нами — мы поможем вам оформить заказ.'
                    ]
                );

                console.error('⚠️⚠️⚠️ <strong>Ошибка в ASK Конструкторе</strong> ⚠️⚠️⚠️\n\n Не передана функция обновления корзины');
            }
        } else {
            showError(
                '⚠️ Ошибка добавления в корзину!',
                [
                    'На сайте возникла техническая проблема, мы уже занимаемся её решением!',
                    'Пожалуйста, свяжитесь с нами — мы поможем вам оформить заказ.'
                ]
            );

            setLoading(prev => ({...prev, submit: false}));

            console.error('⚠️⚠️⚠️ <strong>Ошибка в ASK Конструкторе</strong> ⚠️⚠️⚠️\n\n Не переданы значения для рандомайзера');
        }
    }, [save, setLoading, showError]);


    useEffect(() => {
        if (!isLoading && isSuccess) {
            showSuccess(
                'Ваша сумка успешно добавлена в корзину!',
                'Можете собрать ещё одну или перейти в корзину для покупки.'
            );

            setLoading(prev => ({...prev, submit: false}));
        }
    }, [data, isLoading, isSuccess, setLoading, showError, showSuccess])

    useEffect(() => {
        if (!isLoading && isError) {
            showError(
                'Ошибка на сайте!',
                [
                    'При добавлении в корзину произошла ошибка, попробуйте ешё раз!',
                    'В случае повторения ошибки, свяжитесь с нами и мы поможем вам оформить заказ.'
                ]
            );

            console.error(error);

            setLoading(prev => ({...prev, submit: false}));

            return;
        }
    }, [error, isError, isLoading, setLoading, showError]);


    return {
        addToCart,
    }
}
